import defaults from 'lodash/defaults';
import React, {PureComponent} from 'react';
import {Observable} from 'rxjs/Observable';
import 'rxjs/add/operator/throttleTime';
import 'rxjs/add/operator/map';
import classNames from 'classnames';


const OPTIONS = {
  usePropsClassName: false,
  throttleTime: 1000 / 30,
};

// TODO: handle this globally?
var supportsPassive = false;
try {
  var opts = Object.defineProperty({}, 'passive', {
    get() {
      supportsPassive = true;
    },
  });
  window.addEventListener('test', null, opts);
} catch (e) { /* pass */
}

/**
 * @source https://stackoverflow.com/a/11744120/1800748
 * @return {number}
 */
function getWindowWidth() {
  const w = window;
  const d = document;
  const e = d.documentElement;
  const g = document.body || d.getElementsByTagName('body')[0];
  // const y = w.innerHeight|| e.clientHeight|| g.clientHeight; // if we need height instead
  return w.innerWidth || e.clientWidth || g.clientWidth;
}

/**
 * HoC that injects a `availableWidth` prop to the component, equal to the
 * available width in the current context
 *
 * @param {Object|Component} Component
 * @param {Object} [o]
 * @param {Boolean} [o.usePropsClassName=false]
 * @param {String} [o.wrapperClassName]
 * @param {Number} [o.throttleTime=1000/30]
 * @return {Object} a wrapped Component
 */
export default function withAvailableWidth(Component, o) {
  const options = {};
  defaults(options, o || {}, OPTIONS);

  const getInitialState = () => ({
    availableWidth: void 0,
    windowWidth: getWindowWidth(),
  });
  return class AvailableWidth extends PureComponent {
    constructor() {
      super();
      this.state = getInitialState();
      this._handleDivRef = this._handleDivRef.bind(this);
    }

    componentDidMount() {
      this.resizeSubscription = (supportsPassive
        ? Observable.fromEvent(window, 'resize', {passive: true})
        : Observable.fromEvent(window, 'resize'))
        .throttleTime(options.throttleTime, void 0, {leading: false, trailing: true})
        .map(() => ({
          availableWidth: this._containerElement ? this._containerElement.offsetWidth : void 0,
          windowWidth: getWindowWidth(),
        }))
        .distinctUntilChanged(null, ({availableWidth, windowWidth}) => `${availableWidth}|${windowWidth}`)
        .subscribe(nextState => this.setState(nextState));
    }

    componentWillUnmount() {
      this.resizeSubscription && this.resizeSubscription.unsubscribe();
    }

    _handleDivRef(domElement) {
      if (!domElement || !domElement.parentNode) {
        return;
      }
      this._containerElement = domElement.parentNode;

      this.setState({
        availableWidth: this._containerElement.offsetWidth,
      });
    }

    render() {
      return (
        <div
          ref={this._handleDivRef}
          className={classNames(options.wrapperClassName, {
            [this.props.className]: options.usePropsClassName,
          })}
        >
          <Component
            availableWidth={this.state.availableWidth}
            windowWidth={this.state.windowWidth}
            {...this.props}
          />
        </div>
      );
    }
  };
}



// WEBPACK FOOTER //
// ./src/js/_libs/react-with-available-width/index.js